import { render, staticRenderFns } from "./UpdateDetails.vue?vue&type=template&id=a4790a0a&"
import script from "./UpdateDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports